// Generate a unique session ID
export function generateSessionId() {
    return 'session-' + Math.random().toString(36).slice(2) + Date.now();
  }
  
  export class SessionTimer {
    constructor() {
      this.startTime = Date.now();
      this.lastUserMessageTime = null;
    }
    getSessionDuration() {
      return Date.now() - this.startTime;
    }
    setLastUserMessageTime() {
      this.lastUserMessageTime = Date.now();
    }
    getTimeSinceLastUserMessage() {
      return this.lastUserMessageTime ? Date.now() - this.lastUserMessageTime : 0;
    }
  }
  